import { A as AutoScroll } from './embla-carousel-auto-scroll.esm-7BmXHxKm.js';
import { L as LoopingCarousel } from './looping-carousel-cOAoL2Wk.js';
import './embla-carousel.esm-CCUHK2kO.js';
import './visibility-1aJUVV5h.js';

class USPTicker extends LoopingCarousel() {
  alwaysInit = true;
  emblaOptions = {
    loop: true,
    align: 'start',
    dragFree: true,
    direction: document.dir || 'ltr',
    watchSlides: false,
  };

  get emblaPlugins() {
    return [
      AutoScroll({
        startDelay: 0,
        defaultInteraction: true,
        speed: Number(this.viewport.dataset.speed) || 1,
      }),
    ];
  }
}

customElements.define('usp-ticker', USPTicker);
